export const GET_NATIONALITIES = "GET_NATIONALITIES";

export const GetNationalities = () => {
    return { type: GET_NATIONALITIES };
};
